var __jsx = React.createElement;
import React, { Fragment, useRef } from 'react';
import Transition from '../transition';
import useOnClickOutside from '@lib/hooks/use-onclick-outside';
import useAppearInsideScreen from '@lib/hooks/use-appear-inside-screen';
import APP_CONFIGURATION from '@lib/app.config';
const MuscleDropdown = _ref => {
  let {
    isOpenState,
    setIsOpenState,
    fullLength = false,
    removeHorizontalPaddings = false,
    children,
    alignment = 'left',
    // Default
    buttonRef,
    dataTestId
  } = _ref;
  const dropdownRef = useRef(null);
  useOnClickOutside(buttonRef ? [dropdownRef, buttonRef] : dropdownRef, () => setIsOpenState(false), isOpenState);
  useAppearInsideScreen(dropdownRef, isOpenState);
  const getAlignmentClassName = () => alignment === 'right' ? 'right-0' : alignment === 'center' ? 'left-1/2 transform -translate-x-1/2' : 'left-0';
  return __jsx("div", {
    className: "relative w-full z-20"
  }, __jsx(Transition, {
    show: isOpenState,
    as: Fragment,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95"
  }, __jsx("div", {
    ref: dropdownRef,
    "data-testid": dataTestId,
    className: "absolute z-10 mt-0 min-w-fit bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none ".concat(getAlignmentClassName(), " ").concat(fullLength ? 'w-full' : 'w-fit max-w-full'),
    style: {
      backgroundColor: APP_CONFIGURATION.colors.white
    }
  }, __jsx("div", {
    className: "py-1"
  }, children))));
};
export default MuscleDropdown;